import proj4 from "proj4"
import { register } from 'ol/proj/proj4';

proj4.defs("EPSG:2180", '+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');
register(proj4)
